import styles from "./styles.module.scss";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import ScheduleModal from "app/components/SpaceTabsContainer/ScheduleModal";
import CalendarIco from "../../../public/images/calendar-ico.svg";

const SpaceMenu = ({athleteData}: any) => {
  const { t } = useTranslation();
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);

  const scheduleModalHandler = () => {
    setIsScheduleModalOpen((prev) => !prev);
  };

  return (
    <>
      <ul className={styles.dropdown_list}>
        {/*<li onClick={null}>{t("Scores & Stats")}</li>*/}
        <li onClick={scheduleModalHandler}>
          <img src={CalendarIco} alt="calendar" className={styles.calendar_ico} />
          {t("Bookings")}
        </li>
        {/*<li onClick={null}>{t("Purchases")}</li>*/}
      </ul>

      {isScheduleModalOpen && (
        <ScheduleModal isModalOpen={isScheduleModalOpen} modalHandler={scheduleModalHandler} athleteData={athleteData} />
      )}
    </>
  );
};

export default SpaceMenu;
